// /frontend/src/services/uploadService.js
import apiClient from '../utils/apiClient';

const API_URL = `${process.env.REACT_APP_API_URL || ''}/design-requests`;

export const uploadService = {
  // Upload floor plan file to the server
  uploadFloorPlan: async (formData, progressCallback) => {
    try {
      const response = await apiClient.post(`${API_URL}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          if (progressCallback) {
            progressCallback(percentCompleted);
          }
        },
      });
      
      return response.data;
    } catch (error) {
      console.error('Error uploading floor plan:', error.response?.data || error.message);
      throw error;
    }
  },

  // Get design request by ID
  getDesignRequest: async (requestId) => {
    try {
      const response = await apiClient.get(`${API_URL}/${requestId}`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching design request:', error.response?.data || error.message);
      throw error;
    }
  },

  // Get user's design requests
  getUserDesignRequests: async () => {
    try {
      const response = await apiClient.get(`${API_URL}/my-requests`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching user design requests:', error.response?.data || error.message);
      throw error;
    }
  },

  // Submit a revision request
  submitRevision: async (requestId, revisionDetails) => {
    try {
      const response = await apiClient.post(`${API_URL}/${requestId}/revisions`, {
        details: revisionDetails
      });
      return response.data.data;
    } catch (error) {
      console.error('Error submitting revision request:', error.response?.data || error.message);
      throw error;
    }
  },

  // Update payment status (admin only)
  updatePaymentStatus: async (requestId, paymentStatus) => {
    try {
      // Check if paymentStatus is already an object with a paymentStatus property
      const data = typeof paymentStatus === 'string' 
        ? { paymentStatus } 
        : paymentStatus;
      
      const response = await apiClient.put(`${API_URL}/${requestId}/payment`, data);
      return response.data.data;
    } catch (error) {
      console.error('Error updating payment status:', error.response?.data || error.message);
      throw error;
    }
  },
  
  uploadPaymentEvidence: async (requestId, formData, progressCallback) => {
    try {
      const response = await apiClient.post(`${API_URL}/${requestId}/payment-evidence`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          if (progressCallback) {
            progressCallback(percentCompleted);
          }
        },
      });
      
      return response.data;
    } catch (error) {
      console.error('Error uploading payment evidence:', error.response?.data || error.message);
      throw error;
    }
  },

  updatePaymentMethod: async (requestId, paymentData) => {
    try {
      const response = await apiClient.put(`${API_URL}/${requestId}/payment-method`, paymentData);
      return response.data;
    } catch (error) {
      console.error('Error updating payment method:', error.response?.data || error.message);
      throw error;
    }
  },

  getAdminDesignRequests: async () => {
    try {
      const response = await apiClient.get(`${API_URL}/admin/all`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching admin design requests:', error.response?.data || error.message);
      throw error;
    }
  },
  
  updateStatus: async (requestId, status) => {
    try {
      const response = await apiClient.put(`${API_URL}/${requestId}/status`, { status });
      return response.data.data;
    } catch (error) {
      console.error('Error updating status:', error.response?.data || error.message);
      throw error;
    }
  },

  searchProducts: async (query) => {
    try {
      const response = await apiClient.get(`/products/search?q=${query}`);
      return response.data.data || response.data;
    } catch (error) {
      console.error('Error searching products:', error.response?.data || error.message);
      throw error;
    }
  },
  
  // Update suggested products for a design request
  updateSuggestedProducts: async (requestId, products) => {
    try {
      const response = await apiClient.put(`${API_URL}/${requestId}/suggested-products`, {
        products
      });
      return response.data.data;
    } catch (error) {
      console.error('Error updating suggested products:', error.response?.data || error.message);
      throw error;
    }
  },

  uploadDesignConcept: async (requestId, formData, progressCallback) => {
    try {
      console.log('Uploading concept to:', `${API_URL}/${requestId}/concepts`);
      console.log('Form data:', formData); // Debug log
      
      const response = await apiClient.post(`${API_URL}/${requestId}/concepts`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          if (progressCallback) {
            progressCallback(percentCompleted);
          }
        },
      });
      
      return response.data;
    } catch (error) {
      console.error('Error uploading design concept:', error);
      console.error('Response data:', error.response?.data);
      throw error;
    }
  }
  
};